import { Fragment, useEffect, useState } from "react";
import { Card, CardTitle, CardBody } from "@progress/kendo-react-layout";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../config/globalVariables";
import EventList from "../../containers/Event/List/EventList";
import { EventAdd } from "../../containers/Event/Add/EventAdd";
import EventDateService from "../../services/srv-event/EventDateService";
import { Col, Row } from "reactstrap";
import { EventUpdate } from "../../containers/Event/Add/EventUpdate";

function SummaryCard(text, count, type) {
  return (
    <Card type={type}>
      <CardBody>
        <CardTitle>{count}</CardTitle>
        <p>{text}</p>
      </CardBody>
    </Card>
  );
}

function Events() {
  const { t } = useTranslation();
  const [visibleAddEvent, setVisibleAddEvent] = useState(false);
  const [visibleUpdateEvent, setVisibleUpdateEvent] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [stats, setStats] = useState({});

  useEffect(() => {
    EventDateService.getReport().then((data) => {
      setStats(data.data);
    });
  }, []);

  function toggleDialogAddEvent() {
    setVisibleAddEvent(!visibleAddEvent);
  }
  function toggleDialogUpdateEvent() {
    setVisibleUpdateEvent(!visibleUpdateEvent);
  }
  function goEventDetail(event) {
    window.open(BASE_URL + "event/" + event.etkinliK_TANIM_ID);
  }

  return (
    <Fragment>
      {visibleAddEvent ? (
        <EventAdd
          toggleDialog={toggleDialogAddEvent}
          title={t("event_add")}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></EventAdd>
      ) : (
        ""
      )}

      {visibleUpdateEvent ? (
        <EventUpdate
          toggleDialog={toggleDialogUpdateEvent}
          title={t("event_edit")}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
          event={selectedEvent}
        ></EventUpdate>
      ) : (
        ""
      )}

      <Row>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(t("this_day_event_count"), stats?.dailyCount, "info")}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_week_event_count"),
            stats?.weeklyCount,
            "warning"
          )}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_month_event_count"),
            stats?.monthlyCount,
            "error"
          )}
        </Col>
        <Col lg="3" md="3" sm="6" xs="12" className="mb-2">
          {SummaryCard(
            t("this_year_event_count"),
            stats?.yearlyCount,
            "success"
          )}
        </Col>
      </Row>
      <EventList
        toggleDialogAddEvent={toggleDialogAddEvent}
        goEventDetail={goEventDetail}
        isAdded={isAdded}
        setIsAdded={setIsAdded}
        toggleDialogUpdateEvent={toggleDialogUpdateEvent}
        setSelectedEvent={setSelectedEvent}
        selectedEvent={selectedEvent}
      ></EventList>
    </Fragment>
  );
}

export { Events };
